module.exports = __webpack_public_path__ + "img/P8_popup_thumb_4_tr.4c04d7be.png";